export default "__VITE_ASSET__DiE2vnkg__"